const numberRounded = {
  name: "numberRounded",
  execute: (value) => {
    if (!value || typeof value !== "number") return value;
    return value.toFixed(2);
  },
};

export default numberRounded;
